import { useEffect, useRef } from 'react';
import { useAllhomesContext } from '@domain-group/fe-co-allhomes-global-context';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
var useSendPageView = () => {
  var pageViewSent = useRef(false);
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var _ref = useAllhomesContext() || {},
    user = _ref.user,
    isIdentityLoaded = _ref.isIdentityLoaded,
    watchlist = _ref.watchlist;
  useEffect(() => {
    if (!pageViewSent.current && isIdentityLoaded) {
      sendEvent('page-view', {
        user,
        watchlist
      });
      pageViewSent.current = true;
    }
  }, [isIdentityLoaded, user, watchlist, sendEvent]);
};
export default useSendPageView;